<template>
    <div>
        <!--预定结算-->
        <el-dialog :visible.sync="visible"
                   class="ele-toast" :close-on-click-modal="false" :before-close="resetForm" width="960px">
            <div slot="title">
                <z-title title="婚庆订单结算"></z-title>
            </div>
            <div class="plr-20 lh-30">
                <weddingbase :info="info" showcustom-from></weddingbase>
                <el-divider class="title" content-position="left">预定结算</el-divider>
                <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="90px" class="mt-10">
                    <el-form-item label="额外项目" prop="extraMoney">
                        <div class="flex-n w-270">
                            <el-input-number disabled class="mr-10" v-model="dataForm.extraMoney" :controls="false"
                                             :precision="2" :step="0.1" controls-position="right" :min="0"
                                             :max="9999999999"></el-input-number>
                            <el-button type="primary" @click="showExtra=true">编辑查看</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="使用会员卡" :style="{'margin-bottom':useMemberCard?0:'22px'}">
                        <div>
                            <el-radio-group v-model="useMemberCard">
                                <el-radio :label="false">否</el-radio>
                                <el-radio :label="true">是</el-radio>
                            </el-radio-group>
                        </div>
                    </el-form-item>
                    <el-card class="member_bg " v-if="useMemberCard">

                        <el-form-item label="手机号码" prop="memberPhone">
                            <el-input placeholder="请输入手机号码" class="w-170" v-model="dataForm.memberPhone"></el-input>
                            <el-button class="ml-20" v-if="dataForm.memberPhone&&dataForm.memberPhone.length==11"
                                       @click="searchMemberPhone" @keyup.enter.native="searchMemberPhone">查询
                            </el-button>
                        </el-form-item>

                        <div class="flex-n fac" v-if="searchphone">
                            <el-form-item style="margin-bottom:0" label="会员卡号"> {{memberinfo.memberNo}}
                            </el-form-item>
                            <el-form-item style="margin-bottom:0" label="会员姓名"> {{memberinfo.memberName}}
                            </el-form-item>
                            <el-form-item label-width="110px" style="margin-bottom:0" label="会员卡类别">
                                <template v-if="memberinfo.cardType=='01'&&memberinfo.cardDiscount<10">
                                    <el-tag size="mini" type="success">{{memberinfo.cardTypeName}}</el-tag>
                                    {{memberinfo.cardDiscount}}折
                                </template>
                                <template v-if="memberinfo.cardType=='01'&&memberinfo.cardDiscount==10">
                                    <el-tag size="mini" type="warning">{{memberinfo.cardTypeName}}</el-tag>
                                </template>
                                <template v-if="memberinfo.cardType=='02'">
                                    <el-tag size="mini" type="success">{{memberinfo.cardTypeName}}</el-tag>
                                    {{memberinfo.cardDiscount}}折
                                </template>
                            </el-form-item>
                            <el-form-item label-width="60px" style="margin-bottom:0" label="余额"
                                          v-if="memberinfo.cardType=='01'">
                                {{memberinfo.cardBalance}}
                            </el-form-item>
                        </div>

                    </el-card>
                    <el-form-item label="预计应收" class="mt-20" prop="totalMoney">
                        <div class="flex-n fac">
                            <el-input-number disabled class="mr-10" placeholder="￥" :value="totalMoney"
                                             :controls="false"
                                             :min="0" :precision="2" :step="0.1" :max="9999999999"></el-input-number>
                            <div>元</div>
                            <div class="ml-10">需补差额：{{balanceMoney}}元
                                <template
                                        v-if="memberinfo&&(memberinfo.cardType=='02'||(memberinfo.cardType=='01'&&memberinfo.cardDiscount<10))">
                                    (已享受消费{{memberinfo.cardDiscount}}折)
                                </template>
                            </div>
                            <!--需补差额=应收总额-已收金额-->
                        </div>
                    </el-form-item>

                    <el-form-item label="实收金额" prop="realMoney">
                        <div class="flex-n fac">
                            <el-input-number disabled class="mr-10" placeholder="￥" :value="realMoney"
                                             :controls="false"
                                             :min="0" :precision="2" :step="0.1" :max="9999999999"></el-input-number>
                            <div>元</div>
                        </div>
                    </el-form-item>
                    <div class="flex-n fac">
                        <el-form-item label="收款时间" :show-message="false" prop="date" label-width="110px">
                            <el-date-picker
                                    v-model="dataForm.date"
                                    type="date"
                                    class="w-140"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item class="ml-10" label="" :show-message="false" prop="hour" label-width="0">
                            <el-select class="w-80" filterable v-model="dataForm.hour" placeholder="时">
                                <el-option
                                        v-for="item in hours"
                                        :key="item"
                                        :label="item+'时'"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="ml-10" label="" :show-message="false" prop="minute" label-width="0">
                            <el-select class="w-80" filterable  v-model="dataForm.minute" placeholder="分">
                                <el-option
                                        v-for="item in minutes"
                                        :key="item"
                                        :label="item+'分'"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item><!--<el-form-item label="收款时间" :show-message="false" prop="operateTime" label-width="110px">-->
                        <!--<el-date-picker-->
                        <!--v-model="dataForm.operateTime"-->
                        <!--type="datetime"-->
                        <!--value-format="yyyy-MM-dd HH:mm:ss"-->
                        <!--placeholder="选择日期时间">-->
                        <!--</el-date-picker>-->
                        <!--</el-form-item>-->
                    </div>
                    <div class="flex-n">
                        <el-form-item label="提成方式"  prop="commissionType">
                            <div class="flex-n fac">
                                <el-select v-model="dataForm.commissionType" placeholder="请选择提成规则" value-key="commissionTypeCode">
                                    <el-option label="无提成" value="0"></el-option>
                                    <el-option
                                            v-for="item,index in commissionList"
                                            :key="item.id"
                                            :label="item.commissionTitle"
                                            :value="item.id">
                                    </el-option>
                                    <el-option label="自定义" value="other"></el-option>
                                </el-select>
                                <div class="ml-10" v-if="dataForm.commissionType&&dataForm.commissionType!='other'&&dataForm.commissionType!=0">
                                    {{commissionValue?('提成金额: '+commissionValue):('提成金额: '+0)}}
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="提成金额" prop="commissionValue" v-if="dataForm.commissionType=='other'">
                            <div class="flex-n fac">
                                <el-input-number class="mr-10" placeholder="￥" v-model="dataForm.commissionValue"
                                                 :controls="false"
                                                 :min="0" :precision="2" :step="0.1" :max="9999999999"></el-input-number>
                                <div>元</div>
                            </div>
                        </el-form-item>
                    </div>
                    <el-form-item label="支付渠道" prop="paylist">
                        <div class="flex-n fac">
                            <payment type="object" :memberpay="useMemberCard" v-model="dataForm.paylist"
                                     multiple placeholder="请选择支付渠道"
                                     class="w-520"></payment>
                        </div>
                    </el-form-item>
                    <div class="plr-20">
                        <div class="flex-w">
                            <el-form-item :label="item.dicName" v-for="(item,index) in dataForm.paylist">
                                <el-input-number :controls="false" class="w-120" placeholder="￥" v-model="item.price"
                                                 :precision="2" :step="0.1" controls-position="right"
                                                 :max="9999999999"></el-input-number>
                            </el-form-item>
                        </div>
                    </div>
                    <el-form-item label="备 注" prop="remark">
                        <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                                  maxlength="512"></el-input>
                    </el-form-item>
                    <el-form-item class="mt-10 flex-n fje">
                        <el-button type="primary" @click="submit('dataForm')">保 存</el-button>
                        <el-button @click="resetForm">取 消</el-button>
                    </el-form-item>

                </el-form>
            </div>
        </el-dialog>
        <!--会员卡消费-->
        <use-member-card :visible.sync="showCodeChecked" :phone="dataForm.memberPhone" :memberinfo="memberinfo" @cancel="showCodeChecked=false;useMemberCard=false;dataForm.memberPhone=''" @success="searchphone=true"></use-member-card>
        <!--额外项目-->
        <extra-list title="额外合计项目" is-wedding v-model="extraArea" :visible.sync="showExtra"
                    @getTotal="getTotal"></extra-list>
    </div>
</template>

<script>
    import UseMemberCard from "./UseMemberCard";
    import ZTitle from "../../../components/ZTitle";
    import Weddingbase from "../../component/weddingbase";
    import ExtraList from "../../component/extra";
    import Payment from "../../../components/data/payment";

    export default {
        components: {
            Payment,
            ExtraList,
            Weddingbase,
            ZTitle,
            UseMemberCard},
        name: "wed-order-settlement",
        props:{
            visible: Boolean,
            id: String,
            wedId:String
        },
        data() {
            var validatetel = (rule, value, callback) => {
                console.log(value)
                if (!this.$root.mobileformat.test(value) && value) {
                    return callback(new Error('请输入11位的有效手机号码'));
                }
                return callback();
            };
            var checkconfirmMoney = (rule, value, callback) => {
                console.log(value)
                if (value == '') {
                    return callback(new Error(' '));
                }
                if (Number(value) == 0) {
                    this.$message.error('输入金额必须大于零！');
                    return callback(new Error(' '));
                }
                return callback();
            };
            return {
                loading:false,

                info:{},
                //套餐
                setmealArea: {},
                //额外项目
                extraArea: {},
                showCodeChecked:false,
                useMemberCard: false,//是否使用会员卡
                showExtra:false,//显示额外项目
                hours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
                minutes: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
                    '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
                    '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
                    '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
                    '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
                    '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
                dataForm: {
                    paylist: [],
                    booksdate: '',//预定日期
                    startTime: '',//时间段开始
                    endTime: '',//时间段结束
                    intentpart: '',//预定场地
                    intenttype: '',//预定类型
                    payway: '1',//收费方式
                    everyprice: 0,//每人价格
                    booksnum: 0,//预定人数
                    everytable: 0,//每桌价格
                    bookstables: 0,//预定桌数
                    sparetables: 0,//备用桌数
                    packageprice: 0,//包场价格
                    booksmeals: '',//预定套餐
                    booksunitprice: '',//预定单价
                    extra: '',//额外项目合计金额
                    handsel: '',//已收定金
                    reminddate: '',//提醒日期
                    totalprice: 0.00,//总计应收
                    bookstate: '1',//预定状态
                    comefrom: '',//顾客来源
                    remark: ''//备注
                },
                rules: {
                    memberPhone: [{validator: validatetel, trigger: 'blur'},
                        {required: true, message: ' ', trigger: 'change'}],
                    confirmMoney: [{required: true, validator: checkconfirmMoney, trigger: 'blur'}],
                    paylist:[{required: true, message: ' ', trigger: 'change'}],
                },
                memberinfo: {},
                searchphone: false,
                commissionValue:0,
                commissionList:[]

            }
        },
        watch:{
            visible(newval,oldval){
                if(newval){
                    var date=new Date();
                    this.$set(this.dataForm,'date',date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate());
                    this.$set(this.dataForm,'hour',String(date.getHours()))
                    this.$set(this.dataForm,'minute',String(date.getMinutes()))

                    this.getInfo();
                }
            },
            useMemberCard(newval, oldval) {
                if (!newval) {
                    this.memberinfo = {};
                    this.searchphone = false;

                    for (var i in this.dataForm.paylist) {
                        if (this.dataForm.paylist[i].dicCode == '06') {
                            this.dataForm.paylist.splice(i, 1);
                            break;
                        }
                    }
                }
            },
            'dataForm.commissionType'(newval,oldval){
                if(newval&&newval!='other'&&newval!=0){
                    this.$set(this.dataForm,'commissionValue','');
                    this.getCommssionValue();
                }
            },
            realMoney(newval,oldval){
                if(this.dataForm.commissionType&&this.dataForm.commissionType!='other'&&this.dataForm.commissionType!=0) {
                    this.$set(this.dataForm,'commissionValue','');
                    this.getCommssionValue();
                }
            }
        },
        computed: {
            totalMoney(newval, oldval) {
                console.log('计算')
                // console.log(this.info)
                var dataForm = this.dataForm;
                var value = 0;
                var cardDiscount = this.memberinfo && this.memberinfo.cardDiscount ? this.memberinfo.cardDiscount : 10
                for (var i in this.info.payTypes) {
                    if (this.info.payTypes[i].payTypeCode == '01') {
                        value += Number(dataForm.onePrice1) * Number(dataForm.orderPeople1);
                    }
                    if (this.info.payTypes[i].payTypeCode == '02') {
                        value += Number(dataForm.onePrice2) * Number(dataForm.orderPeople2);
                    }
                    if (this.info.payTypes[i].payTypeCode == '03') {
                        value += Number(dataForm.orderall);
                    }
                }
                value += Number(this.dataForm.extraMoney);
                this.dataForm.needMoney = value;
                return value * (cardDiscount / 10).toFixed(2)
            },
            realMoney() {
                var value = 0;
                for (var i in this.dataForm.paylist) {
                    value += Number(this.dataForm.paylist[i].price||0);
                }
                this.dataForm.realMoney = value;
                console.log(value)
                return value;
            },
            balanceMoney() {
                var value = (Number(this.totalMoney||0) - (Number(this.dataForm.realPayment) || 0)).toFixed(2)
                return value;
            }
        },
        methods:{
            getCommssionValue(){
                var payTypes=[];
                for (var i in this.info.payTypes) {
                    if (this.info.payTypes[i].payTypeCode == '01') {
                        payTypes.push({
                            housePrice: 0,
                            onePrice: Number(this.dataForm.onePrice1),
                            orderCount: Number(this.dataForm.orderPeople1),
                            payTypeCode: '01',
                        })
                    }
                    if (this.info.payTypes[i].payTypeCode == '02') {
                        payTypes.push({
                            housePrice: 0,
                            onePrice: Number(this.dataForm.onePrice2),
                            orderCount: Number(this.dataForm.orderPeople2),
                            bakOrderCount: Number(this.dataForm.bdesks),
                            payTypeCode: '02',
                        })
                    }
                    if (this.info.payTypes[i].payTypeCode == '03') {
                        payTypes.push({
                            housePrice: Number(this.dataForm.orderall),
                            payTypeCode: '03'
                        })
                    }
                }

                this.$axios.post('/userCommission/calcOrderCommission',{
                    "orderCommissionConfigId": this.dataForm.commissionType,
                    "orderRealMoney": this.realMoney,
                    "orderPayments": payTypes
                }).then(res=>{
                    this.commissionValue=res.data.commissionMoney;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },

            getInfo(){
                //上半部基本信息
                this.$axios.get('/wedding/orderWeddingDetail/' + this.wedId).then(res => {
                    console.log(res)
                    var info = res.data;
                    this.extraArea = {
                        itemsExTree: info.extra
                    }
                    this.dataForm.extraMoney = info.exItemMoney;
                    this.info = info;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var dataForm = this.dataForm;
                        var payment = [], extraArea = {},consumeMoney=0;
                        for (var i in this.dataForm.paylist) {
                            payment.push({
                                "payMoney": this.dataForm.paylist[i].price||0,
                                "paymentCode": this.dataForm.paylist[i].dicCode,
                                "paymentName": this.dataForm.paylist[i].dicName,
                            });
                            if(this.dataForm.paylist[i].dicCode=='06'){
                                consumeMoney= this.dataForm.paylist[i].price||0;
                            }
                        }
                        extraArea = JSON.parse(JSON.stringify(this.extraArea).replace(/itemsExTree/g, 'itemsExs'));
                        this.$axios.post('/weddingClear/weddingPayment', {
                            "storeId": this.$root.getStorage('storeId'),
                            "orderId": this.orderId,
                            "weddingOrderId": this.wedId,
                            "extraMoney": dataForm.extraMoney,//额外项目金额
                            "payment": payment,//支付方式
                            "operateTime":dataForm.date+' '+dataForm.hour+':'+dataForm.minute,//操作时间
                            "memberInfo":{
                                "memberPhone":dataForm.memberPhone,
                                "consumeMoney":consumeMoney
                            },
                            "isMemberPay":this.useMemberCard?1:0,
                            "orderExtra": extraArea,//额外项目内容
                            "realMoney": dataForm.realMoney,//实收金额
                            "needMoney": dataForm.needMoney,//应收金额
                            "remark": dataForm.remark,
                            "balanceMoney": this.balanceMoney,
                            "orderPackage": dataForm.orderPackage,
                        }).then(res => {
                            this.$message.success('婚庆预定结算成功！');
                            this.resetForm();
                        }).catch(err => {
                            this.$message.error(err.msg);
                        })
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });

            },
            searchMemberPhone() {
                this.loading2 = true;
                if (this.dataForm.memberPhone.length == 11) {

                    this.$axios.post('member/memberByPhoneAndStoreId/' , {
                        "storeId": this.$root.getStorage('storeId'),
                        "memberPhone": this.dataForm.memberPhone
                    }).then(res => {
                        console.log(res)
                        this.loading2 = false;
                        if(res.data){
                            if (res.data.cardType == '01'){
                                this.showCodeChecked = true;
                            }else{
                                this.searchphone=true;
                            }

                            this.memberinfo = res.data;//会员信息
                        }else{
                            this.$message.error('该账户不是会员或者存在异常，请联系管理员');
                        }

                    }).catch(err => {
                        this.memberinfo = null;
                        this.$message.error(err.msg);
                        this.loading2 = false;
                    })
                } else {
                    this.memberinfo = null;
                    this.loading2 = false;
                }
            },
            getTotal(data) {
                this.dataForm.extraMoney = data.nowPrice;
            },
            getSummaries(param) {
                const {columns, data} = param;
                const sums = ['累计收款', '', '', '', ''];
                var sum = 0;
                for (var i = 0, len = data.length; i < len; i++) {
                    sum += Number((data[i].confirmType == 1 ? '-' : '') + Number(data[i].confirmMoney));
                }
                sums[5] = sum;
                return sums;
            },
            resetForm(){
                this.memberinfo = {};
                this.searchphone = false;
                this.useMemberCard = false;

                this.$refs.dataForm.resetFields();
                this.showCodeChecked=false;//选择会员置为初始
                this.$emit('refreshList');
                this.$emit('update:visible', false);
            }

        },
    }
</script>

<style scoped lang="scss">
    .el-divider__text {
        font-weight: 700 !important;
        color: #5295e7;
    }

</style>